<template>
  <div style="padding-bottom: 20%">
    <van-sticky>
      <van-dropdown-menu>
        <van-dropdown-item :title="selectTitle" ref="statusselect">
          <van-cell center @click="setStatus('all')" :title="allTitle.all"><template #right-icon><van-badge :content="countInfo.all" /></template></van-cell>
          <van-cell center @click="setStatus('needBalance4Deliver')" :title="allTitle.needBalance4Deliver"><template #right-icon><van-badge :content="countInfo.needBalance4DeliverCount" /></template></van-cell>
          <van-cell center @click="setStatus('undeliver')" :title="allTitle.undeliver"><template #right-icon><van-badge :content="countInfo.unDeliver" /></template></van-cell>
          <van-cell center @click="setStatus('delivering')" :title="allTitle.delivering"><template #right-icon><van-badge :content="countInfo.delivering" /></template></van-cell>
          <van-cell center @click="setStatus('needBalanceReceived')" :title="allTitle.needBalanceReceived"><template #right-icon><van-badge :content="countInfo.needBalanceReceived" /></template></van-cell>
          <van-cell center @click="setStatus('received')" :title="allTitle.received"><template #right-icon><van-badge :content="countInfo.received" /></template></van-cell>
        </van-dropdown-item>
      </van-dropdown-menu>
      <van-search
        v-model="listQuery.orderNumber"
        :show-action="true"
        :clearable="false"
        :action-text="$t('common.clear')"
        :placeholder="$t('order.number')"
        input-align="center"
        @search="refreshOrders"
        @cancel="clearSearch"
      />
    </van-sticky>
    <van-pull-refresh v-model="pullRefreshing" @refresh="refreshOrders">
      <van-list
        v-model="listLoading"
        :finished="listFinished"
        :finished-text="$t('common.noMore')"
        :immediate-check="false"
        @load="onLoad"
      >
        <div v-for="order in orders" :key="order.id" class="order-item">
          <div class="order-item-title">
            <van-row>
              <van-col span="1"></van-col>
              <van-col span="11" class="order-title-content order-title-bold">{{ order.number }}</van-col>
              <van-col span="11" class="order-title-content order-title-right">{{ order.statusText }}</van-col>
              <van-col span="1"></van-col>
            </van-row>
            <van-row>
              <van-col span="1"></van-col>
              <van-col span="11" class="order-title-content">{{ order.orderTime }}</van-col>
              <van-col span="11" class="order-title-content order-title-right">
                <span class="href-type" @click="showPriceInfo(order)">S/. {{ order.totalOriginalPrice }}</span>
              </van-col>
              <van-col span="1"></van-col>
            </van-row>
            <van-row>
              <van-col span="1"></van-col>
              <van-col span="23" class="order-title-content">{{ order.receiveAddress }} ({{ order.receiverName }}/{{ order.receiverPhone }})</van-col>
            </van-row>
          </div>
          <div class="order-item-content">
            <van-row v-if="order.status==10&&order.balanceDelivery>0&&!order.balanceDeliveryPayed||order.status==30&&order.balanceAmount>0&&!order.balancePayed">
              <van-col span="12">
                <van-button size="small" type="primary" @click="showProducts(order.items)">{{ $t('order.seeProducts') }}</van-button>
              </van-col>
              <van-col span="12">
                <van-button size="small" type="warning" @click="showPay(order)">{{ $t('order.payOrder') }}</van-button>
              </van-col>
            </van-row>
            <van-row v-else>
              <van-col span="24">
                <van-button size="small" type="primary" @click="showProducts(order.items)" class="half-width">{{ $t('order.seeProducts') }}</van-button>
              </van-col>
            </van-row>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>

    <van-popup position="bottom" closeable round v-model="priceInfoShow">
      <div class="prop-content">
        <h4>{{ $t('order.priceDetail') }}</h4>
        <van-row>
          <van-col span="12" class="column-title">{{ $t('order.originalPrice') }}:</van-col>
          <van-col span="12" class="column-content">{{ priceInfo.originalPrice }}</van-col>
        </van-row>
        <van-row>
          <van-col span="12" class="column-title">{{ $t('order.deposit') }}:</van-col>
          <van-col span="12" class="column-content">{{ priceInfo.deposit }}</van-col>
        </van-row>
        <van-row>
          <van-col span="12" class="column-title">{{ $t('order.agentFreight') }}:</van-col>
          <van-col span="12" class="column-content">{{ priceInfo.agentFreight }}</van-col>
        </van-row>
        <van-row v-if="priceInfo.needPay">
          <van-col span="12" class="column-title">{{ $t('order.needPay') }}:</van-col>
          <van-col span="12" class="column-content">{{ priceInfo.needPayAmount }}</van-col>
        </van-row>
        <van-row v-if="priceInfo.needPay">
          <van-col span="1"></van-col>
          <van-col span="22" class="payprice-des">{{ priceInfo.needPayDes }}</van-col>
          <van-col span="1"></van-col>
        </van-row>
      </div>
    </van-popup>

    <van-popup position="bottom" closeable round v-model="productInfoShow">
      <div class="prop-content">
        <h4>{{ $t('order.seeProducts') }}</h4>
        <van-row v-for="product in products" :key="product.id" class="product-row">
          <van-col span="8" class="product-name">
            <span class="href-type" @click="showPic(product.pic)">{{ product.productName }}({{ product.spec }})</span>
          </van-col>
          <van-col span="16" class="product-des">S/. {{ product.unitPrice }} * {{ product.count }}{{ product.countUnit }}</van-col>
        </van-row>
      </div>
    </van-popup>

    <van-popup v-model="picShow">
      <van-image
        width="20rem"
        fit="contain"
        :src="productPic"
      />
    </van-popup>

    <van-popup v-model="selectPayShow" position="bottom">
      <div class="select-pay-div">
        <p class="pay-title">{{ payingOrder.amountCurrency }} {{ payingOrder.amountCurrency=='SOL'?payingOrder.needPayAmount:payingOrder.needPayAmountOfUSD }}</p>
        <van-button type="warning" size="large" @click="payOrderBalance(payingOrder.id,payingOrder.balanceType)">StarPay</van-button>
        <div v-if="payingOrder.acceptVisa">
          <p>{{ $t('order.otherPayMethod') }}</p>
          <img style="width:100%" src="https://storage.googleapis.com/starpay_file/credit_cards.png" />
          <van-radio-group class="select-currency" v-model="payingOrder.amountCurrency" direction="horizontal">
            <van-radio name="SOL">SOL</van-radio>
            <van-radio name="USD">USD</van-radio>
          </van-radio-group>
          <van-button v-if="niubizJsLoaded" :loading="niubizPaying" type="warning" size="large" @click="payByNiubiz(payingOrder.id,payingOrder.number,payingOrder.balanceType,payingOrder.amountCurrency)">{{ $t('order.creditCard') }}</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import i18n from '@/i18n'
import { Toast, Dialog } from 'vant'
import { countByStatus, listOrders, payBalanceByStarPay } from '@/api/order'
import { generateVisaPayRecord, getNiuBizConfig } from '@/api/pay'
import { getToken, getUserId } from '@/util/auth'
import loadJs from '@/util/loadJs'

export default {
  data() {
    return {
      selectTitle: i18n.t('order.all'),
      allTitle: {
        all: i18n.t('order.all'),
        needBalance4Deliver: i18n.t('order.needBalance') + '(' + i18n.t('order.unDeliver') + ')',
        undeliver: i18n.t('order.unDeliver'),
        delivering: i18n.t('order.delivering'),
        needBalanceReceived: i18n.t('order.needBalance') + '(' + i18n.t('order.received') + ')',
        received: i18n.t('order.received')
      },
      countInfo: {
        all: 0,
        needBalance4DeliverCount: 0,
        unDeliver: 0,
        delivering: 10,
        needBalanceReceived: 0,
        received: 10,
      },
      listQuery: {
        statusTag: 'all',
        orderNumber: '',
        page: 1
      },
      orders: [],
      pullRefreshing: false,
      listLoading: false,
      listFinished: true,
      priceInfoShow: false,
      priceInfo: {
        originalPrice: '',
        deposit: '',
        agentFreight: '',
        needPay: false,
        needPayAmount: '',
        needPayDes: '',
      },
      productInfoShow: false,
      products: [],
      productPic: '',
      picShow: false,
      selectPayShow: false,
      payingOrder: {
        id: 0,
        number: '',
        balanceType: '',
        acceptVisa: false,
        amountCurrency: 'SOL',
        needPayAmount: 0,
        needPayAmountOfUSD: 0
      },
      niubizJsLoaded: false,
      niubizPaying: false,
      userInfo: {
        id: 0,
        token: ''
      }
    }
  },
  created() {
    this.userInfo.id = getUserId()
    this.userInfo.token = getToken()
    this.fecthStatusCount()
    this.fetchOrders()
  },
  mounted() {
    // const testUrl = 'https://static-content-qas.vnforapps.com/v2/js/checkout.js?qa=true'
    const productUrl = 'https://static-content.vnforapps.com/v2/js/checkout.js'
    loadJs(productUrl).then(() => {
      this.niubizJsLoaded = true
    })
  },
  methods: {
    fecthStatusCount() {
      countByStatus().then(rep => {
        this.countInfo = rep.data
      })
    },
    fetchOrders() {
      this.listLoading = true
      this.listFinished = false
      listOrders(this.listQuery).then(rep => {
        this.orders.push(...rep.data.orders)
        this.pullRefreshing = false
        this.listLoading = false
        if (rep.data.orders.length == 0) {
          this.listFinished = true
        }
      }).catch(() => {})
    },
    refreshOrders() {
      this.orders = []
      this.listQuery.page = 1
      this.fetchOrders()
    },
    onLoad() {
      this.listQuery.page++
      this.fetchOrders()
    },
    clearSearch() {
      this.listQuery.orderNumber = ''
      this.orders = []
      this.listQuery.page = 1
      this.fetchOrders()
    },
    setStatus(status) {
      this.listQuery.statusTag = status
      this.selectTitle = this.allTitle[status]
      this.refreshOrders()
      this.$refs.statusselect.toggle()
    },
    showPriceInfo(order) {
      this.priceInfo.originalPrice = order.totalOriginalPrice
      this.priceInfo.deposit = order.depositAmount || 0
      this.priceInfo.agentFreight = order.agentFreight || 0
      this.priceInfo.needPay = false
      if (order.status == 10 && !order.balanceDeliveryPayed && order.balanceDelivery > 0) {
        this.priceInfo.needPay = true
        this.priceInfo.needPayAmount = parseFloat((parseFloat(order.balanceDelivery || 0) + parseFloat(order.serviceFeeCustomer || 0)).toFixed(2))
        this.priceInfo.needPayDes = (order.balanceDelivery > 0 ? i18n.t('order.needBalance') + ':' + order.balanceDelivery + ';' : '') +
                                    (order.serviceFeeCustomer > 0 ? i18n.t('order.serviceFee') + ':' + order.serviceFeeCustomer : '')
      } else if (order.status == 30 && !order.balancePayed && order.balanceAmount > 0) {
        this.priceInfo.needPay = true
        this.priceInfo.needPayAmount = parseFloat((parseFloat(order.balanceAmount || 0) + (order.balanceDelivery > 0 ? 0 : parseFloat(order.serviceFeeCustomer || 0))).toFixed(2))
        this.priceInfo.needPayDes = i18n.t('order.needBalance') + ':' + order.balanceAmount + (order.balanceDelivery > 0 ? '' : i18n.t('order.serviceFee') + ':' + order.serviceFeeCustomer)
      }
      this.priceInfoShow = true
    },
    showProducts(products) {
      this.products = products
      this.productInfoShow = true
    },
    showPay(order) {
      this.payingOrder.id = order.id
      this.payingOrder.number = order.number
      this.payingOrder.balanceType = order.status==10 ? 'deliver' : 'received'
      this.payingOrder.acceptVisa = order.supplierAcceptVisa
      const exchangeUSDRate = 0.263
      if (order.status == 10 && !order.balanceDeliveryPayed && order.balanceDelivery > 0) {
        this.payingOrder.needPayAmount = parseFloat((parseFloat(order.balanceDelivery || 0) + parseFloat(order.serviceFeeCustomer || 0)).toFixed(2))
      } else if (order.status == 30 && !order.balancePayed && order.balanceAmount > 0) {
        this.payingOrder.needPayAmount = parseFloat((parseFloat(order.balanceAmount || 0) + (order.balanceDelivery > 0 ? 0 : parseFloat(order.serviceFeeCustomer || 0))).toFixed(2))
      }
      this.payingOrder.needPayAmountOfUSD = parseFloat((this.payingOrder.needPayAmount * exchangeUSDRate).toFixed(2))
      this.selectPayShow = true
    },
    payOrderBalance(orderId, balanceType) {
      Dialog.confirm({
        title: i18n.t('order.confirmPayBalance'),
      }).then(() => {
        payBalanceByStarPay({ orderId: orderId, balanceType: balanceType }).then(rep => {
          if (rep.code == 1000) {
            Toast.success(i18n.t('order.paySuccess'))
            this.fecthStatusCount()
            this.refreshOrders()
            this.selectPayShow = false
          }
        }).catch(() => {
        })
      }).catch(() => {
          // on cancel
      });
    },
    payByNiubiz(orderId, orderNumber, balanceType, currency) {
      this.niubizPaying = true
      let visaPayRecordId
      let amount
      let _that = this
      setTimeout(() => {
        _that.niubizPaying = false
      }, 10000)
      generateVisaPayRecord({ orderId: orderId, balanceType: balanceType,currency: currency }).then(rep => {
        visaPayRecordId = rep.data.visaPayRecordId
        amount = rep.data.amount
        return getNiuBizConfig({ userId: this.userInfo.id, amount: amount, currency: currency })
      }).then(rep => {
        const actionUrl = process.env.VUE_APP_BASE_API + 'o/pay/payByNiuBiz?visaPayRecordId=' +
          visaPayRecordId + '&amount=' + amount + '&currency=' + currency + '&orderId=' + orderId + '&orderNumber=' + orderNumber +
          '&balanceType=' + balanceType + '&userId=' + this.userInfo.id + '&userToken=' + this.userInfo.token
        VisanetCheckout.configure({
          sessiontoken: rep.data.sessionToken,
          channel: 'web',
          merchantid: rep.data.merchantId,
          purchasenumber: visaPayRecordId,
          amount: amount,
          expirationminutes: '20',
          timeouturl: 'about:blank',
          merchantlogo: 'https://storage.googleapis.com/starpay_file/logo_name.png',
          formbuttoncolor: '#000000',
          action: actionUrl,
          complete: function(params) {
          }
        })
        VisanetCheckout.open()
      }).catch(() => {})
    },
    showPic(picUrl) {
      this.productPic = picUrl
      this.picShow = true
    }
  }
}
</script>

<style scoped>
.order-item {
  margin-bottom: 15px;
  border: 1px solid #e0e0e0;
  font-size: 14px;
  color: #646566;
}
.order-item-title {
  background-color: #f3f6f5;
}
.order-title-content {
  padding-top: 3px;
  padding-bottom: 3px;
}
.order-title-bold {
  font-weight: bold;
  color: #323233;
}
.order-title-right {
  text-align: right;
}
.prop-content {
  font-size: 16px;
  padding-bottom: 20px;
}
.prop-content h4 {
  text-align: center;
}
.order-item-content .van-col {
  text-align: center;
  padding-top: 5px;
  padding-bottom: 5px;
}
.order-item-content .van-col .van-button {
  /* width: 10rem; */
  padding-left: 1rem;
  padding-right: 1rem;
}
.product-name {
  text-align: center;
  font-size: 14px;
}
.product-des {
  text-align: center;
  font-size: 14px;
}
.product-row {
  padding-bottom: 8px;
}
.payprice-des {
  text-align: center;
  color: #969799;
}
.select-pay-div {
  padding: 0.5rem 2rem;
}
.pay-title {
  text-align: center;
  font-weight: bold;
}
.select-currency {
  margin: 0.5rem 0;
}
</style>